import { render } from "./RegistrationPostman.vue?vue&type=template&id=0d498fb7&scoped=true"
import script from "./RegistrationPostman.vue?vue&type=script&lang=js"
export * from "./RegistrationPostman.vue?vue&type=script&lang=js"

import "./RegistrationPostman.vue?vue&type=style&index=0&id=0d498fb7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d498fb7"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBanner,QSpinner});
